var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"white","stroke":"none","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 22C15 22 20.8261 16.9185 21.7191 13.7633C23.3457 8.01611 17.4841 6.28182 15 9.86193C12.5155 6.28182 6.65429 8.01611 8.28091 13.7633C9.1739 16.9185 15 22 15 22Z","stroke":"black","strokeWidth":"2","key":1})]);
}

Heart.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Heart;

Heart.default = Heart;
